<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.grupo"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-grupo-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-grupo"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-grupo"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories = {
            grupo: this.getConectaSusRepository('cadastro.grupo')
        }
    },
    computed: {

        fields() {

            return [
                {
                    name: 'cadastroGrupo.nome',
                    key: 'nome',
                    label: 'Nome',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastroGrupoTipo.nome',
                    key: 'grupoTipo',
                    label: 'Tipo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.grupo.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o grupo?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>